import musicListeningPlatformMvp from './music-listening-platform-mvp';
import eLearning from './e-learning';

import movieDatabase from './movie-database';
import socialNetwork from './social-network';
import holidayAccommodation from './holiday-accommodation';
import dietitian from './dietitian';
import healthcareInsurance from './healthcare-insurance';
import ABtestingPlatform from './a-b-testing-platform';
import jobManagementPlatform from './job-management-platform';
import golfWeb from './golf-web';
import golfIOs from './golf-ios';
import classifiedAdvertising from './classified-advertising';
import authenticationiOS from './authentication-ios';
import financeApp from './finance-app';

export { 
    musicListeningPlatformMvp, eLearning, holidayAccommodation, dietitian, healthcareInsurance, 
    ABtestingPlatform, jobManagementPlatform, golfWeb, golfIOs, socialNetwork,
    classifiedAdvertising, movieDatabase, authenticationiOS, financeApp
}


// WEBPACK FOOTER //
// ./src/store/portfolio/index.tsx